import { FC } from 'react';
import { Box, Stack, styled } from '@mui/material';

import { StylePatternSegment, StylePatternSegmentProps } from '@components/base';
import { getPatternSegment } from '@modules/layouts/components/layoutPreview/utils';

export type StylePatternPreviewProps = Pick<StylePatternSegmentProps, 'discrete' | 'size'> & {
  additionalCount?: number;
  /**
   * Fade percentage
   */
  fade?: number;
  minCount?: number;
  pattern: string;
  repeatLastSegment?: boolean;
};

const StyledWrapper = styled(Box)<Pick<StylePatternPreviewProps, 'fade'>>`
  display: flex;
  mask-image: linear-gradient(to right, black ${({ fade }) => fade}%, transparent);
  max-width: 100%;
  overflow: hidden;
  position: relative;
  width: fit-content;
`;

export const StylePatternPreview: FC<StylePatternPreviewProps> = ({
  additionalCount = 4,
  discrete,
  fade = 80,
  minCount = 8,
  pattern,
  repeatLastSegment,
  size,
}) => {
  const patterns = pattern.split(',');
  const count = Math.max(minCount, patterns.length + additionalCount);

  return (
    <StyledWrapper fade={fade}>
      <Stack alignItems='center' direction='row' mr={-0.25} position='relative' spacing={0.25}>
        {Array.from(Array(count).keys()).map(i => {
          const patternSegment =
            i >= patterns.length && repeatLastSegment
              ? getPatternSegment(pattern, patterns.length - 1)
              : getPatternSegment(pattern, i);

          return (
            <StylePatternSegment
              discrete={discrete}
              groupStylePattern={patternSegment}
              key={i}
              size={size}
            />
          );
        })}
      </Stack>
    </StyledWrapper>
  );
};

StylePatternPreview.displayName = 'StylePatternPreview';
